module.exports = {
  color: require('./src/color'),
  size: require('./src/size'),
  symbol: require('./src/symbol')
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/no-extend.js
// module id = 5
// module chunks = 0